import { createAction } from '@reduxjs/toolkit';

export const updateUser = createAction('personalisation/UPDATE_USER');
